module.exports = __webpack_public_path__ + "img/login-ba.e412cb44.png";